import axios from 'axios';
import { notifyHelper } from './notifyHelper';
const httpStatusUnauthorized = 401;
const httpStatusForbidden = 403;
const returnUrlParam = 'returnUrl';
const pathLogin = '/account/login';
const pathNoRedirect = '/account';
const showError = (error) => {
    if (error && error.code !== 0) {
        notifyHelper.danger(error.message, error.description);
    }
    if (error && error.code === 0) {
        notifyHelper.success(error.message, error.description);
    }
};
const isResultObject = (object) => object && (object.error || object.data);
const returnRequestResult = async (url, method, data) => {
    let request;
    if (method === 'GET') {
        request = await axios.get(url);
    }
    else if (method === 'DELETE') {
        request = await axios.delete(url);
    }
    else {
        request = await axios({ url, method, data });
    }
    return request;
};
async function axiosRequest(url, method, data, notify = true, redirect = true) {
    try {
        const result = await returnRequestResult(url, method, data);
        if (isResultObject(result.data)) {
            const retObj = result.data;
            if (retObj.error) {
                showError(retObj.error);
            }
            return retObj.data;
        }
        return result.data; // For any other type
    }
    catch (err) {
        const { response } = err;
        if (!notify) {
            return response.data.data;
        }
        const { error } = response.data;
        if (error && error.message && error.description) {
            notifyHelper.danger(error.message, error.description);
        }
        else if (redirect && response.status === httpStatusUnauthorized) {
            const uri = encodeURIComponent(window.location.pathname);
            if (uri.toLocaleLowerCase().startsWith(pathNoRedirect)) {
                window.location.href = pathLogin;
            }
            else {
                window.location.href = `${pathLogin}?${returnUrlParam}=${uri}`;
            }
        }
        else if (redirect && response.status === httpStatusForbidden) {
            window.location.href = pathLogin;
        }
        else {
            notifyHelper.danger('ERROR', 'Problem z połączeniem');
        }
        return response.data.data;
    }
}
export { axiosRequest, };
